/**
 * Ô "Thêm sản phẩm" của PI — ảnh, giá mua gần nhất của khách, quy đổi đơn giá (yêu cầu v1.8 mục 4.5, 4.6, 6.4; 11/10/2026).
 */
export const piPickerEn = {
  currencyFromCompany: "{{currency}} — default currency of {{company}}. You can still choose another.",
  listPrice: "Catalogue",
  piNo: "PI {{no}}",
  lastSale: "Last purchase",
  lastSaleTitle: "This customer's most recent purchase of this product — date, PI number, unit price and unit all come from the same PI line. Reference only: it never replaces the price on this PI.",
  noHistory: "No purchase history",
  pickCustomer: "Choose the bill-to customer to see the last purchase",
  historyError: "Could not load purchase history",
};

export const piPickerVi: typeof piPickerEn = {
  currencyFromCompany: "{{currency}} — tiền tệ mặc định của công ty {{company}}. Vẫn chọn tiền tệ khác được.",
  listPrice: "Giá danh mục",
  piNo: "PI {{no}}",
  lastSale: "Lần mua gần nhất",
  lastSaleTitle: "Lần gần nhất khách này mua sản phẩm này — ngày, số PI, đơn giá và đơn vị đều lấy từ cùng một dòng PI. Chỉ để tham khảo: không bao giờ tự thay giá trên PI này.",
  noHistory: "Chưa có lịch sử mua",
  pickCustomer: "Chọn khách (Bill to) để xem lần mua gần nhất",
  historyError: "Không tải được lịch sử mua",
};

export const piPickerZh: typeof piPickerEn = {
  currencyFromCompany: "{{currency}}——{{company}}公司的默认币种，仍可改选其他币种。",
  listPrice: "目录价",
  piNo: "PI {{no}}",
  lastSale: "最近一次购买",
  lastSaleTitle: "该客户最近一次购买此产品的记录——日期、PI 编号、单价与单位均取自同一 PI 明细。仅供参考，不会自动替换本 PI 的价格。",
  noHistory: "无购买记录",
  pickCustomer: "请先选择付款方客户以查看最近一次购买",
  historyError: "无法载入购买记录",
};
